import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import AnnualReportTimeline from "./annualReportTimeline";
import { ExpandableViewPanel } from "components/common";
import { ManageAssistantsButton } from "./manageAssistants";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TimeLineWidget: React.FC = () => {
  return (
    <ExpandableViewPanel
      icon={IconDefinitionConstants.WCalendarTime}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.StateOfAnnualReport)}
      appearance="lg"
      gridSize="lg"
      isCanvasContent
      className={cssExports.noPadding}
      expanded
      loading
      topRightContent={<ManageAssistantsButton />}
    >
      <AnnualReportTimeline />
    </ExpandableViewPanel>
  );
};

export default TimeLineWidget;
